import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { Router } from "@angular/router";
import { ServiceConfig } from "./service-config";
import { HttpClient } from "@angular/common/http";
@Injectable()
export class DepartmentService {
  private host = ServiceConfig.host;
  private baseUrl = this.host + "/api/department/";
  // public baseUrl = 'http://localhost/api/department/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient, private router: Router) {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
    this.headers = new Headers({
      "Content-Type": "application/json",
    });
    this.options = { headers: this.headers };
  }

  public index() {
    let url = this.baseUrl + "?token=" + this.data.token;
    return this.http.get<any>(url);
  }
  public getDepartmentPermission() {
    const url = this.baseUrl + '/department-permission?token=' + this.data.token;
    return this.http.get<any>(url);
  }
  public getByCurrentUser() {
    let url = this.baseUrl + "get-by-current-user?token=" + this.data.token;
    return this.http.get<any>(url);
  }
  public getParents() {
    let url = this.baseUrl + "getParents?token=" + this.data.token;
    return this.http.get<any>(url);
  }

  public create(body) {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
    let url = this.baseUrl + "create?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public update(departmentId: String, body) {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
    let url = this.baseUrl + departmentId + "/update?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public delete(departmentId: String) {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
    let url = this.baseUrl + departmentId + "/delete?token=" + this.data.token;
    return this.http.post<any>(url, null);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/department.service.ts